/** @file True when an id list names every slot of the document exactly once (setup order, draw-order keys). */
import type { Doc } from './schema';

/** True when `order` lists every slot of `doc` exactly once. */
export function isSlotPermutation(doc: Doc, order: readonly string[]): boolean {
  return order.length === Object.keys(doc.slots).length && new Set(order).size === order.length && order.every((id) => Object.hasOwn(doc.slots, id));
}
